export default __webpack_public_path__ + "static/media/MX.472e765e.svg";